<template>
  <div class="color-container">
    <h4>颜色设置</h4>
    <div class="color-wrap">
      <div v-for="(color, i) in colors" :key="i" class="color-box">
        <el-color-picker
          v-model="color.color0"
          class="color-picker color-picker-0"
          color-format="hex"
          title="线条颜色设置"
        />
        <div class="color-2">
          <el-color-picker
            v-model="color.color1"
            class="color-picker color-picker-1"
            color-format="hex"
            title="列表背景颜色设置"
          />
          <el-color-picker
            v-model="color.color2"
            class="color-picker color-picker-1"
            color-format="hex"
            title="列表字体颜色设置"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      colors: [],
    }
  },

  mounted() {
    this.refresh()
  },

  activated() {
    this.refresh()
  },

  methods: {
    getGlobalColor() {
      return cloneDeep(this.$store.state.app.maptheme || [])
    },

    saveColor() {
      this.$store.commit('UPDATE_MAP_THEME', cloneDeep(this.colors))
    },

    refresh() {
      this.colors = this.getGlobalColor()
    },
  },
}
</script>

<style lang="scss">
.color-container {
  .color-wrap {
    // width: 100%;
    padding: 20px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .color-box {
    position: relative;
    border-radius: 4px;
    height: 80px;
    width: 120px;
    box-sizing: border-box;
    color: #fff;
    font-size: 14px;

    display: inline-block;

    .color-2 {
      width: 100%;
      height: 40px;
      left: 0;
      bottom: 0;
      position: absolute;
    }

    .color-picker {
      .el-color-picker__color,
      .el-color-picker__trigger {
        height: 100%;
        width: 100%;
        border: none;
      }

      .el-color-picker__trigger {
        padding: 0;
      }

      .el-color-picker__icon {
        display: none;
      }

      &.color-picker-0 {
        height: 100%;
        width: 100%;
      }

      &.color-picker-1 {
        width: 50%;
        height: 100%;
        display: inline-block;
      }
    }
  }
}
</style>
